import { SelectOption } from '@framework/form';
import { useCurrentLocale, useTranslation } from '@framework/i18n';
import { getNames as getCountryName, registerLocale } from 'i18n-iso-countries';
import EN from 'i18n-iso-countries/langs/en.json';
import IT from 'i18n-iso-countries/langs/it.json';
import { EidasCountryCodeList } from './EIDASCountryCodeList';

// Libreria, lingue e paesi disponibili: https://www.npmjs.com/package/i18n-iso-countries

// Registro le lingue italiano e inglese
registerLocale(EN);
registerLocale(IT);

/**
 * Hook che genera la lista dei paesi extra-europei nel format <codice> - <nome_paese>.
 * Sfrutta la libreria i18-iso-countries per tradurre i nomi dei paesi.
 */
export function useExtraEuCountryCode() {
  const { t } = useTranslation();

  const { language } = useCurrentLocale();

  const countries = getCountryName(language, { select: 'official' });

  const options = Object.keys(countries)
    // Escludiamo i paesi EIDAS
    .filter(code => !EidasCountryCodeList.some(eu => eu == code))
    // Rimuovo l'Italia dalla lista
    .filter(code => code !== 'IT')
    .map(
      code =>
        ({
          value: code,
          label: `${code} - ${
            countries[code] ??
            t('user-registration.country.unkown', 'Sconosciuto')
          }`,
        } as SelectOption),
    );

  return { options };
}
